var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course"},[_c('div',{staticClass:"couse-cover"},[_c('UiDish',{attrs:{"title":"お料理"}}),_c('UiPrice',{attrs:{"type":0,"description":"季節にあわせた鍋物料理もご用意できます"}}),_c('div',{staticClass:"cover"},[_c('router-link',{attrs:{"to":"/menu"}},[_vm._v(" 詳細はこちら ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }